import { BaseObjectEntity } from '@/types';
import { path } from '@/utils/formatLink';

export const ROOT_TRANSACTIONS = '/transactions';

export const PATH_TRANSACTIONS: BaseObjectEntity = {
  root: ROOT_TRANSACTIONS,
  list: '',
};

export function transactionsPath(pathKey: string) {
  return path(ROOT_TRANSACTIONS, PATH_TRANSACTIONS[pathKey]);
}
